import { Chip } from "@mui/material";

interface StatusChipProps {
  status: string;
  variant?: "success" | "warning" | "error" | "info" | "default";
  size?: "small" | "medium";
}

// Modern color configuration - softer, more refined
const colorConfig = {
  success: {
    backgroundColor: "#EDFCF2",
    color: "#16A34A",
  },
  warning: {
    backgroundColor: "#FFFBEB",
    color: "#D97706",
  },
  error: {
    backgroundColor: "#FEF2F2",
    color: "#DC2626",
  },
  info: {
    backgroundColor: "#EFF6FF",
    color: "#2563EB",
  },
  default: {
    backgroundColor: "#F1F5F9",
    color: "#64748B",
  },
};

export const StatusChip = ({
  status,
  variant = "default",
  size = "small",
}: StatusChipProps) => {
  const colors = colorConfig[variant];

  return (
    <Chip
      label={status}
      size={size}
      sx={{
        fontWeight: 600,
        fontSize: size === "small" ? "11px" : "12px",
        borderRadius: "8px",
        height: size === "small" ? "24px" : "28px",
        letterSpacing: "0.02em",
        ...colors,
        border: `1px solid ${colors.color}18`,
        "& .MuiChip-label": {
          px: 1.5,
        },
      }}
    />
  );
};

// Helper function to determine variant based on status string
export const getStatusVariant = (
  status: string
): "success" | "warning" | "error" | "info" | "default" => {
  const statusLower = status.toLowerCase();

  if (
    statusLower.includes("complete") ||
    statusLower.includes("approved") ||
    statusLower.includes("success") ||
    statusLower.includes("active") ||
    statusLower.includes("paid") ||
    statusLower.includes("verified")
  ) {
    return "success";
  }

  if (
    statusLower.includes("pending") ||
    statusLower.includes("processing") ||
    statusLower.includes("waiting") ||
    statusLower.includes("in progress") ||
    statusLower.includes("in_progress") ||
    statusLower.includes("review") ||
    statusLower.includes("invited")
  ) {
    return "warning";
  }

  if (
    statusLower.includes("cancel") ||
    statusLower.includes("reject") ||
    statusLower.includes("failed") ||
    statusLower.includes("error") ||
    statusLower.includes("blocked") ||
    statusLower.includes("inactive")
  ) {
    return "error";
  }

  if (
    statusLower.includes("info") ||
    statusLower.includes("scheduled") ||
    statusLower.includes("upcoming")
  ) {
    return "info";
  }

  return "default";
};
